import React, { Fragment } from "react";
import BaseUIComponent from "../../Components/BaseUIComponent";
import { connect } from "react-redux";
import { getCountryMasterList, getMessage } from "../../Constants/CommonConstants";
import { imageResize } from "../../Components/Tools/ImageTools";
import { updateSendingOrganizationInfo, updateSendingOrganizationInfoReset } from "./GCMOMCRU03Action";
import { MessageMap } from "./GCMOMCRU03Message";
import ErrorMessage from "../../Components/Atoms/ErrorMessage";
import TextInput from "../../Components/Atoms/TextInput";
import "../../Css/Common.css";

/**
 * 組織情報(プロフィール)送り出し機関
 */
class GCMOMCRU03 extends BaseUIComponent {

    constructor(props) {
        super(props);
        this.state = {
            countryOpt: [],
            sendingOrganizationInfo: this.props.detailData
        };
    }

    /**
     * 初期化イベント
     */
    componentDidMount = () => {
        const { sendingOrganizationInfo } = this.state;
        // 国・地域名
        const countryRet = Object.entries(getCountryMasterList()).map(([k, v]) => {
            return v;
        });

        this.setState(prevState => ({
            countryOpt: [...prevState.countryOpt, ...countryRet],
            sending_organization_name: sendingOrganizationInfo.sending_organization_name,
            sending_organization_logo: sendingOrganizationInfo.sending_organization_logo,
            sending_organization_location: sendingOrganizationInfo.sending_organization_location,
            pic_name: sendingOrganizationInfo.pic_name,
            pic_mail_address: sendingOrganizationInfo.pic_mail_address,
            pic_tel_country_name: sendingOrganizationInfo.pic_tel_country_name,
            pic_tel_country_code: sendingOrganizationInfo.pic_tel_country_code,
            pic_tel1: sendingOrganizationInfo.pic_tel1,
            pic_tel2: sendingOrganizationInfo.pic_tel2,
            pic_tel3: sendingOrganizationInfo.pic_tel3,
        }), () => {
            countryRet.forEach(country => {
                // 担当者電話番号
                if (country.country_code === this.state.pic_tel_country_code) {
                    this.setState({
                        pic_tel_country_name: country.country_name,
                        pic_tel_country_code: country.country_code,
                        pic_tel_country_number: country.country_number
                    });
                }
            });
        });
        window.scrollTo(0, 0);
    }

    /**
     * 画像を変更
     * @param {*} event
     */
    handleImageUpload = (event) => {
        imageResize(event.target, (data) => {
            this.setState({
                sending_organization_logo: data
            }, () => {
                this.editItemHandler('sending_organization_logo', this.state.sending_organization_logo);
            });
        });
    }

    /**
     * 画像を削除
     */
    handleImageDelete = () => {
        this.setState({
            sending_organization_logo: null
        }, () => {
            this.editItemHandler('sending_organization_logo', this.state.sending_organization_logo);
        });
    };

    /**
     * 代表者電話番号の変更
     * @param {*} event
     */
    handleTelCountryNameChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        }, () => {
            if (this.state.pic_tel_country_name === '') {
                this.setState({
                    pic_tel_country_number: '',
                    pic_tel_country_code: ''
                }, () => {
                    this.editItemHandler("pic_tel_country_code", this.state.pic_tel_country_code);
                    this.editItemHandler("pic_tel_country_name", this.state.pic_tel_country_name);
                    this.editItemHandler("pic_tel_country_number", this.state.pic_tel_country_number);
                });
            }
            this.state.countryOpt && this.state.countryOpt.forEach(country => {
                // 担当者電話番号＿国・地域名
                if (country.country_name === this.state.pic_tel_country_name) {
                    this.setState({
                        pic_tel_country_code: country.country_code,
                        pic_tel_country_number: country.country_number
                    }, () => {
                        this.editItemHandler("pic_tel_country_code", this.state.pic_tel_country_code);
                        this.editItemHandler("pic_tel_country_name", this.state.pic_tel_country_name);
                        this.editItemHandler("pic_tel_country_number", this.state.pic_tel_country_number);
                    });
                }
            });
        });
    };

    /**
    * 画面部品編集イベント
    * @param {*} name
    * @param {*} value
    */
    editItemHandler = (name, value) => {
        this.setState(prevState => ({
            sendingOrganizationInfo: {
                ...prevState.sendingOrganizationInfo,
                [name]: value
            }
        }));
    }

    /**
   * ローディング、エラー画面リセット
   */
    saveReset = () => {
        this.props.sendingOrganizationInfoReset();
    }

    /**
     * 登録
     */
    saveSendingOrganizationInfo = () => {
        window.scrollTo(0, 0);
        // システムエラーのコールバック設定
        this.setErrorCallback(this.saveReset);

        let reqData = JSON.parse(JSON.stringify(this.state.sendingOrganizationInfo));
        this.props.createSendingOrganizationInfo(reqData);
    }


    /**
     * 画面切替処理
     * @param {*} changeTo
     * @param {*} isReset
     */
    handleToDisplay = (changeTo, isReset) => {
        if (isReset) {
        }
        return this.props.changeDisp(changeTo, isReset);
    }

    render() {
        const { sendingOrganizationInfo } = this.state;
        if (!this.props.isFetching) {
            // 最新バージョン設定する
            if (this.props.data && this.props.data.version_no != null && sendingOrganizationInfo.version_no != this.props.data.version_no) {
                this.editItemHandler('version_no', this.props.data.version_no);
                this.showModalDialog(0, getMessage('RS-0036'), () => { });
            }
        }
        return (
            <Fragment>
                <div className="ly_cont">
                    <div className="bl_mainHeader">
                        <div className="bl_mainHeader_inner">
                            <h1 className="el_lv1Heading">
                                組織情報(プロフィール)
                            </h1>
                        </div>
                    </div>
                    <div className="ly_mainCont">
                        <nav className="bl_breadcrumb">
                            <ol className="bl_breadcrumb_list">
                                <li>
                                    <a href="#!" onClick={() => this.showModalDialog(1, getMessage('RS-0066'), () => { this.getMenu().gotoHome(); }, () => { })}>ホーム</a>
                                </li>
                                <li>組織情報(プロフィール)</li>
                            </ol>
                        </nav>
                        <section className="bl_sect">
                            <div className="ly_mainCont_inner">
                                <ErrorMessage err_type={this.props.err_type} err_detail={this.props.err_detail} messageMap={MessageMap} />
                                <div className="bl_sect_header">
                                    <h2 className="el_lv2Heading">登録プロフィール情報</h2>
                                </div>
                                <div className="bl_sect_inner">
                                    <section className="bl_sect_frame">
                                        <table className="bl_horizTable">
                                            <tbody>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        送り出し機関名
                                                    </th>
                                                    <td>
                                                        <TextInput type="text" name="sending_organization_name" className="el_input el_input__max" maxlength="60" required="required" setValue={sendingOrganizationInfo.sending_organization_name} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="1" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>ロゴ</th>
                                                    <td>
                                                        <div className="bl_upload_box__applicant">
                                                            <figure>
                                                                <img src={this.state.sending_organization_logo == null ? 'data:,' : this.state.sending_organization_logo} alt="" />
                                                            </figure>
                                                            <div className="bl_btns">
                                                                <label htmlFor="changeImg" onClick={event => event.target.value = null} className="el_smBlueBtn" tabIndex="2">画像を選択<br />Select image
                                                                    <input type="file" id="changeImg" className="el_sendFile" name="sending_organization_image" accept="image/*" onChange={this.handleImageUpload} />
                                                                </label>
                                                                <label htmlFor="deleteImg" className="el_smBlueBtn" tabIndex="3">画像を削除<br />Delete image
                                                                    <input type="button" id="deleteImg" className="el_sendFile" onClick={this.handleImageDelete} />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        所在地
                                                    </th>
                                                    <td>
                                                        <TextInput type="text" name="sending_organization_location" className="el_input el_input__max" maxlength="60" required="required" setValue={sendingOrganizationInfo.sending_organization_location} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="4" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        担当者名
                                                    </th>
                                                    <td>
                                                        <TextInput type="text" name="pic_name" className="el_input el_input__max" maxlength="40" required="required" setValue={sendingOrganizationInfo.pic_name} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="5" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        担当者メールアドレス
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <TextInput type="text" name="pic_mail_address" className="el_input el_input__max" maxlength="81" required="required" setValue={sendingOrganizationInfo.pic_mail_address} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="6" />
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <span className="el_badge el_badge__required">必須</span><br />
                                                        担当者電話番号
                                                    </th>
                                                    <td>
                                                        <div className="bl_formUnit">
                                                            <select className="el_select el_select_country" name="pic_tel_country_name" onChange={this.handleTelCountryNameChange} tabIndex="7">
                                                                <option value="" selected ></option>
                                                                {
                                                                    this.state.countryOpt && this.state.countryOpt.map(item => (
                                                                        <option key={item.country_code} value={item.country_name} selected={this.state.pic_tel_country_name == item.country_name}>
                                                                            {item.country_name}
                                                                        </option>
                                                                    ))
                                                                }
                                                            </select>
                                                        </div>
                                                        <TextInput type="text" name="pic_tel_country_number" className="el_input el_input__countryCode" setValue={this.state.pic_tel_country_number} maxlength="6" readOnly={true} />
                                                        <TextInput type="text" name="pic_tel1" className="el_input el_input__phoneNum" maxlength="4" required="required" setValue={sendingOrganizationInfo.pic_tel1} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="8" />&nbsp;-&nbsp;
                                                        <TextInput type="text" name="pic_tel2" className="el_input el_input__phoneNum" maxlength="4" required="required" setValue={sendingOrganizationInfo.pic_tel2} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="9" />&nbsp;-&nbsp;
                                                        <TextInput type="text" name="pic_tel3" className="el_input el_input__phoneNum" maxlength="4" required="required" setValue={sendingOrganizationInfo.pic_tel3} onHandleChange={(k, v) => this.editItemHandler(k, v)} tabIndex="10" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </section>
                                    <div className="bl_horizBtnUnit">
                                        <button type="button" className="el_btn" onClick={() => this.saveSendingOrganizationInfo()} tabIndex="11">登録する</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </Fragment>
        );
    }
}

// この関数は第一引数はstore.getState()の結果を第一引数に、このContainer componentへ渡されたpropsを第二引数にして呼び出され、
// これらのstateとpropsを使って子のcomponentにpropsとして渡す値を生成する
const mapStateToProps = (state) => {
    return {
        isFetching: state.updateSendingOrganizationInfo.isFetching,
        data: state.updateSendingOrganizationInfo.data,
        isError: state.updateSendingOrganizationInfo.isError,
        err_type: state.updateSendingOrganizationInfo.err_type,
        err_detail: state.updateSendingOrganizationInfo.err_detail
    };
};

// この関数は，store.dispatchを第一引数にして呼び出される関数で、
// dispatchを使って子のcomponentにpropsとして渡す関数を生成する
const mapDispatchToProps = dispatch => {
    return {
        createSendingOrganizationInfo(arg) {
            // 組織情報(プロフィール)送り出し機関取得
            dispatch(updateSendingOrganizationInfo(arg));
        },
        sendingOrganizationInfoReset() {
            // actionCreatorの関数を使用してactionをdispatchに返してそれを実行している。
            // その後、createStoreで登録したreducerに処理が移る
            dispatch(updateSendingOrganizationInfoReset());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GCMOMCRU03);

